$.fn.exists = function exists() {
  return Boolean(this.length > 0);
};
